import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiClock, FiUsers, FiStar, FiPlay } = FiIcons

const CourseCard = ({ course, showProgress = false, progress = null }) => {
  return (
    <motion.div
      whileHover={{ y: -4 }}
      className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-300"
    >
      {/* Course Image */}
      <div className="relative h-48 bg-gradient-to-br from-nutrition-100 to-nutrition-200">
        {course.cover_image_url ? (
          <img
            src={course.cover_image_url}
            alt={course.title}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <SafeIcon icon={FiPlay} className="w-12 h-12 text-nutrition-600" />
          </div>
        )}
        {course.price > 0 && (
          <div className="absolute top-4 right-4 bg-white rounded-full px-3 py-1 text-sm font-semibold text-gray-900">
            ${course.price}
          </div>
        )}
      </div>

      {/* Course Content */}
      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-2 line-clamp-2">
          {course.title}
        </h3>
        
        {course.summary && (
          <p className="text-gray-600 text-sm mb-4 line-clamp-3">
            {course.summary}
          </p>
        )}

        {/* Progress Bar */}
        {showProgress && progress && (
          <div className="mb-4">
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm text-gray-600">Progress</span>
              <span className="text-sm font-semibold text-nutrition-600">
                {progress.percentage}%
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-nutrition-600 h-2 rounded-full transition-all duration-300" 
                style={{ width: `${progress.percentage}%` }}
              />
            </div>
            <div className="flex justify-between items-center mt-1 text-xs text-gray-500">
              <span>{progress.completed} of {progress.total} lessons</span>
            </div>
          </div>
        )}

        {/* Course Stats */}
        <div className="flex items-center space-x-4 text-sm text-gray-500 mb-4">
          <div className="flex items-center space-x-1">
            <SafeIcon icon={FiClock} className="w-4 h-4" />
            <span>Self-paced</span>
          </div>
          <div className="flex items-center space-x-1">
            <SafeIcon icon={FiUsers} className="w-4 h-4" />
            <span>All levels</span>
          </div>
          <div className="flex items-center space-x-1">
            <SafeIcon icon={FiStar} className="w-4 h-4" />
            <span>4.8</span>
          </div>
        </div>

        {/* Action Button */}
        <Link
          to={showProgress ? `/course/${course.slug}` : `/courses/${course.slug}`}
          className="w-full bg-nutrition-600 hover:bg-nutrition-700 text-white py-2 px-4 rounded-lg font-medium transition-colors flex items-center justify-center space-x-2"
        >
          <span>{showProgress ? 'Continue Learning' : 'View Course'}</span>
          <SafeIcon icon={FiPlay} className="w-4 h-4" />
        </Link>
      </div>
    </motion.div>
  )
}

export default CourseCard